import React from 'react'
import './featureCard.css'

const FeatureCard = ({ logo, title, description }) => {
  return (
    <div className="feature__card">
      <img src={logo} alt="logo" />
      <h3>{title}</h3>
      <p>{description}</p>
    </div>
  )
}

export default FeatureCard
